"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4 3h16v2H4zm4 8h3v10h2V11h3l-4-4z"
}), 'VerticalAlignTopTwoTone');